// NexGen shared design tokens
const THEME_STORAGE_KEY = "nexgen_theme";

const chartColors = [
  "#00D4FF", "#FF3D57", "#FFB800", "#00E676", "#A78BFA",
  "#F97316", "#EC4899", "#14B8A6", "#84CC16", "#FB923C"
];

export const themeModes = {
  dark: {
    mode: "dark",
    scheme: "dark",
    label: "Dark",
    colors: {
      bg: "#050D1A",
      bgGrid: "rgba(0,212,255,0.03)",
      sidebar: "#080F1E",
      topbar: "rgba(8,15,30,0.9)",
      card: "#0C1628",
      cardElevated: "#101D33",
      cardBorder: "#1A2744",
      inputBg: "#06101E",
      inputBgDisabled: "#040A14",
      tableHeader: "#06101E",
      rowAlt: "rgba(255,255,255,0.01)",
      rowAltStrong: "rgba(255,255,255,0.02)",
      overlay: "rgba(5, 13, 26, 0.92)",
      accent: "#00D4FF",
      accentDim: "#0099BB",
      accentGlow: "rgba(0,212,255,0.15)",
      danger: "#FF3D57",
      dangerGlow: "rgba(255,61,87,0.15)",
      warning: "#FFB800",
      success: "#00E676",
      textPrimary: "#F0F8FF",
      textSecondary: "#A8C8E8",
      textMuted: "#6B8DB0",
      textLabel: "#8BB8D8",
      brandText: "#FFFFFF",
      buttonText: "#000000",
      shadow: "0 0 60px rgba(0,0,0,0.8)",
      shadowSoft: "0 18px 46px rgba(0,0,0,0.25)",
      chartColors
    }
  },
  cleanNavy: {
    mode: "cleanNavy",
    scheme: "light",
    label: "Clean Navy",
    colors: {
      bg: "#FFFFFF",
      bgGrid: "rgba(26,90,154,0.05)",
      sidebar: "#F4F7FC",
      topbar: "rgba(244,247,252,0.97)",
      card: "#FFFFFF",
      cardElevated: "#F8FAFD",
      cardBorder: "#D0D8E8",
      inputBg: "#F8FAFD",
      inputBgDisabled: "#EEF3FA",
      tableHeader: "#F0F4FA",
      rowAlt: "rgba(26,90,154,0.035)",
      rowAltStrong: "rgba(26,90,154,0.06)",
      overlay: "rgba(244, 247, 252, 0.92)",
      accent: "#1A5A9A",
      accentDim: "#104078",
      accentGlow: "rgba(26,90,154,0.12)",
      danger: "#AA2233",
      dangerGlow: "rgba(170,34,51,0.12)",
      warning: "#B8860B",
      success: "#1A6A30",
      textPrimary: "#1A2744",
      textSecondary: "#2A3A5A",
      textMuted: "#5A6A84",
      textLabel: "#345B86",
      brandText: "#1A2744",
      buttonText: "#FFFFFF",
      shadow: "0 14px 46px rgba(26,39,68,0.13)",
      shadowSoft: "0 8px 24px rgba(26,39,68,0.08)",
      chartColors
    }
  },
  monochrome: {
    mode: "monochrome",
    scheme: "dark",
    label: "Black & White",
    colors: {
      bg: "#000000",
      bgGrid: "rgba(255,255,255,0.03)",
      sidebar: "#000000",
      topbar: "rgba(0,0,0,0.95)",
      card: "#000000",
      cardElevated: "#0A0A0A",
      cardBorder: "#FFFFFF",
      inputBg: "#000000",
      inputBgDisabled: "#0A0A0A",
      tableHeader: "#000000",
      rowAlt: "rgba(255,255,255,0.02)",
      rowAltStrong: "rgba(255,255,255,0.04)",
      overlay: "rgba(0,0,0,0.95)",
      accent: "#FFFFFF",
      accentDim: "#CCCCCC",
      accentGlow: "rgba(255,255,255,0.10)",
      danger: "#FFFFFF",
      dangerGlow: "rgba(255,255,255,0.08)",
      warning: "#FFFFFF",
      success: "#FFFFFF",
      textPrimary: "#FFFFFF",
      textSecondary: "#DDDDDD",
      textMuted: "#AAAAAA",
      textLabel: "#CCCCCC",
      brandText: "#FFFFFF",
      buttonText: "#000000",
      shadow: "0 0 30px rgba(255,255,255,0.05)",
      shadowSoft: "0 8px 24px rgba(255,255,255,0.03)",
      chartColors: ["#FFFFFF","#FFFFFF","#FFFFFF","#FFFFFF","#FFFFFF","#FFFFFF","#FFFFFF","#FFFFFF","#FFFFFF","#FFFFFF"]
    }
  },
  grayScale: {
    mode: "grayScale",
    scheme: "dark",
    label: "Gray-Scale",
    colors: {
      bg: "#131216",
      bgGrid: "rgba(236,236,236,0.028)",
      sidebar: "#131216",
      topbar: "rgba(19,18,22,0.94)",
      card: "#2e2d30",
      cardElevated: "#444448",
      cardBorder: "#54535c",
      inputBg: "#2e2d30",
      inputBgDisabled: "#444448",
      tableHeader: "#2e2d30",
      rowAlt: "rgba(236,236,236,0.035)",
      rowAltStrong: "rgba(236,236,236,0.065)",
      overlay: "rgba(19, 18, 22, 0.92)",
      accent: "#c7c8c9",
      accentDim: "#a9abae",
      accentGlow: "rgba(199,200,201,0.14)",
      danger: "#bcbbbe",
      dangerGlow: "rgba(188,187,190,0.12)",
      warning: "#a9abae",
      success: "#c7c8c9",
      textPrimary: "#ececec",
      textSecondary: "#ececec",
      textMuted: "#ececec",
      textLabel: "#ececec",
      brandText: "#ececec",
      buttonText: "#131216",
      shadow: "0 18px 48px rgba(0,0,0,0.48)",
      shadowSoft: "0 10px 26px rgba(0,0,0,0.28)",
      chartColors: ["#ececec", "#c7c8c9", "#bcbbbe", "#a9abae", "#9c9c9c", "#929598", "#8c8c94", "#727377"]
    }
  },
  codexGray: {
    mode: "codexGray",
    scheme: "dark",
    label: "Grayful",
    colors: {
      bg: "#131216",
      bgGrid: "rgba(167,139,250,0.035)",
      sidebar: "#131216",
      topbar: "rgba(19,18,22,0.95)",
      card: "#2e2d30",
      cardElevated: "#353438",
      cardBorder: "#54535c",
      inputBg: "#2e2d30",
      inputBgDisabled: "#444448",
      tableHeader: "#2e2d30",
      rowAlt: "rgba(236,236,236,0.035)",
      rowAltStrong: "rgba(167,139,250,0.06)",
      overlay: "rgba(19, 18, 22, 0.92)",
      accent: "#A78BFA",
      accentDim: "#7E57C2",
      accentGlow: "rgba(167,139,250,0.16)",
      danger: "#EF3333",
      dangerGlow: "rgba(239,51,51,0.13)",
      warning: "#FF9800",
      success: "#2E9D44",
      textPrimary: "#ececec",
      textSecondary: "#c7c8c9",
      textMuted: "#8aa8c6",
      textLabel: "#7FA3C5",
      brandText: "#ececec",
      buttonText: "#131216",
      shadow: "0 18px 48px rgba(0,0,0,0.48)",
      shadowSoft: "0 10px 26px rgba(0,0,0,0.28)",
      chartColors: [
        "#EF3333", "#FF8C00", "#F9A825", "#2E9D44", "#1565C0",
        "#A78BFA", "#00A0B5", "#EC4899", "#8aa8c6", "#c7c8c9"
      ]
    }
  },
  nature: {
    mode: "nature",
    scheme: "light",
    label: "Nature",
    colors: {
      bg: "#EBD2B4",
      bgGrid: "rgba(79,116,108,0.055)",
      sidebar: "#EBD2B4",
      topbar: "rgba(235,210,180,0.94)",
      card: "#FFF5E6",
      cardElevated: "#F3C8B8",
      cardBorder: "#B99C7A",
      inputBg: "#FFF5E6",
      inputBgDisabled: "#E3D8C4",
      tableHeader: "#E3D8C4",
      rowAlt: "rgba(152,86,70,0.055)",
      rowAltStrong: "rgba(79,116,108,0.09)",
      overlay: "rgba(235, 210, 180, 0.92)",
      accent: "#4F746C",
      accentDim: "#476972",
      accentGlow: "rgba(79,116,108,0.15)",
      danger: "#985646",
      dangerGlow: "rgba(152,86,70,0.13)",
      warning: "#BF8859",
      success: "#6D7961",
      textPrimary: "#4F3F3A",
      textSecondary: "#755C57",
      textMuted: "#755C57",
      textLabel: "#755C57",
      brandText: "#4F3F3A",
      buttonText: "#FFF5E6",
      shadow: "0 16px 44px rgba(117,92,87,0.18)",
      shadowSoft: "0 8px 24px rgba(117,92,87,0.12)",
      chartColors: [
        "#985646", "#4F746C", "#BF8859", "#6D7961", "#476972",
        "#C07869", "#8DA279", "#F39474", "#6CA2AF", "#9B7E78"
      ]
    }
  }
};

export const themeOptions = Object.values(themeModes).map(({ mode, label }) => ({ mode, label }));

const normalizeThemeMode = (mode) => {
  if (mode === "light" || mode === "navy") return "cleanNavy";
  return themeModes[mode] ? mode : "dark";
};

const readStoredThemeMode = () => {
  try {
    return normalizeThemeMode(window.localStorage.getItem(THEME_STORAGE_KEY));
  } catch {
    return "dark";
  }
};

export const getThemeMode = () => readStoredThemeMode();

export const setNexGenThemeMode = (mode) => {
  const nextMode = normalizeThemeMode(mode);
  try {
    window.localStorage.setItem(THEME_STORAGE_KEY, nextMode);
  } catch {}
};

const selectedMode = readStoredThemeMode();

export const theme = {
  ...themeModes[selectedMode],
  fonts: {
    display: "'Orbitron', 'Share Tech Mono', monospace",
    body: "'Exo 2', 'Rajdhani', sans-serif",
    mono: "'Share Tech Mono', 'Fira Code', monospace"
  }
};

export const globalStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@400;600;700;900&family=Exo+2:wght@300;400;500;600;700&family=Share+Tech+Mono&display=swap');

  * { box-sizing: border-box; margin: 0; padding: 0; }

  body {
    background: ${theme.colors.bg};
    color: ${theme.colors.textPrimary};
    font-family: 'Exo 2', sans-serif;
    overflow-x: hidden;
  }

  ::selection {
    background: ${theme.colors.accentGlow};
    color: ${theme.colors.textPrimary};
  }

  ::-webkit-scrollbar { width: 6px; height: 6px; }
  ::-webkit-scrollbar-track { background: ${theme.colors.cardElevated}; }
  ::-webkit-scrollbar-thumb { background: ${theme.colors.cardBorder}; border-radius: 3px; }
  ::-webkit-scrollbar-thumb:hover { background: ${theme.colors.accent}66; }

  input, select, textarea, button {
    color-scheme: ${theme.scheme};
  }

  .nexgen-card {
    background: ${theme.colors.card};
    border: 1px solid ${theme.colors.cardBorder};
    border-radius: 12px;
    padding: 20px;
    box-shadow: ${theme.scheme === "light" ? theme.colors.shadowSoft : "none"};
  }

  .nexgen-card:hover {
    border-color: ${theme.colors.accent}55;
    box-shadow: 0 0 20px ${theme.colors.accentGlow};
  }

  .glow-text {
    color: ${theme.colors.accent};
  }

  .danger-row { background: ${theme.colors.dangerGlow} !important; }
  .warning-row { background: rgba(255,184,0,0.08) !important; }

  @keyframes pulse-glow {
    0%, 100% { box-shadow: 0 0 5px ${theme.colors.accentGlow}; }
    50% { box-shadow: 0 0 20px ${theme.colors.accentGlow}; }
  }

  @keyframes fadeInUp {
    from { opacity: 0; transform: translateY(20px); }
    to { opacity: 1; transform: translateY(0); }
  }

  .animate-in {
    animation: fadeInUp 0.4s ease forwards;
  }

  ${theme.mode === 'monochrome' ? `
    /* ── Black & White chart overrides ── */
    .recharts-bar-rectangle rect,
    .recharts-bar-rectangle path,
    .recharts-layer.recharts-bar-rectangle path {
      fill: #FFFFFF !important;
      stroke: #000000 !important;
      stroke-width: 1.5 !important;
    }
    .recharts-pie-sector path { stroke: #000000 !important; stroke-width: 2 !important; }
    .recharts-cell { stroke: #000000 !important; stroke-width: 2 !important; }
    .recharts-line-curve { stroke: #FFFFFF !important; }
    .recharts-area-area { fill: rgba(255,255,255,0.12) !important; }
    .recharts-area-curve { stroke: #FFFFFF !important; }
    .recharts-scatter-symbol circle { fill: #FFFFFF !important; stroke: #000000 !important; stroke-width: 1.5 !important; }
    .recharts-cartesian-axis-tick-value,
    .recharts-cartesian-axis-tick text { fill: #FFFFFF !important; }
    .recharts-cartesian-grid line { stroke: rgba(255,255,255,0.15) !important; }
    .recharts-legend-item-text { color: #FFFFFF !important; }
    .recharts-default-tooltip {
      background: #000000 !important;
      border: 1px solid #FFFFFF !important;
      color: #FFFFFF !important;
    }
    .recharts-label { fill: #FFFFFF !important; }
    .recharts-bar-label text { fill: #000000 !important; }
    .danger-row { background: rgba(255,255,255,0.06) !important; }
    .warning-row { background: rgba(255,255,255,0.04) !important; }
  ` : ''}
`;
